var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetSlice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-track-changes",
    "data-name": "Icon material-track-changes",
    d: "M28.6,7.395,26.49,9.51A12.013,12.013,0,1,1,16.5,6.1v3.03a9,9,0,1,0,7.86,2.505l-2.115,2.115A6.015,6.015,0,1,1,16.5,12.21v3.21A2.97,2.97,0,0,0,15,18a3,3,0,0,0,6,0,2.952,2.952,0,0,0-1.5-2.58V3H18A15.005,15.005,0,1,0,28.6,7.4Z",
    transform: "translate(-3 -3)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSlice);
export default __webpack_public_path__ + "static/media/targetSlice.ec395eb7.svg";
export { ForwardRef as ReactComponent };